module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero-toyota.061f00db.png";